import {isNormalExceeding} from './DateRangeValidation.js';

export default function validate(values) {
    const errors = {};

    if (!values.searchQueries || !values.searchQueries.length) {
        errors.searchQueries = {
          _error: 'no_fields'
        }
    } else {
        const queryArrayErrors = [];

        values.searchQueries.forEach((query, index) => {
            const queryErrors = {};
            const type = query.attribute.type;

            if (query && query.innerFields && query.innerFields.length) {
                 const innerFieldsErrors = [];

                 query.innerFields.forEach((field, fieldIndex) => {
                     const fieldErrors = {};
                     if (type === 'date' || type === 'year') {
                         if (field.relation !== 'IS_EMPTY' && field.relation !== 'CONTAINS_ANYTHING' && !field.valueFrom && !field.valueTo) {
                             fieldErrors.valueFrom = 'required';
                             fieldErrors.valueTo = 'required';
                         }

                         if (field.valueFrom && field.valueTo && type === 'date') {
                              const dateArrFrom = field.valueFrom.replace(/_/g, '').split('.').map(date => parseInt(date, 10));
                              const dateArrTo = field.valueTo.replace(/_/g, '').split('.').map(date => parseInt(date, 10));

                              const dateDayFrom = dateArrFrom[0];
                              const dateMonthFrom = dateArrFrom[1];
                              const dateYearFrom = dateArrFrom[2];

                              const dateDayTo = dateArrTo[0];
                              const dateMonthTo = dateArrTo[1];
                              const dateYearTo = dateArrTo[2];

                              const isNormalExceedingCurrent = isNormalExceeding(dateDayFrom, dateMonthFrom, dateYearFrom, dateDayTo, dateMonthTo, dateYearTo);

                              if (isNormalExceedingCurrent) {
                                  fieldErrors.valueFrom = 'to_exceeds_from';
                              }
                         }

                         if (field.valueFrom && field.valueTo && type === 'year') {
                              const dateArrFrom = field.valueFrom.replace(/_/g, '').split('.').map(date => parseInt(date, 10));
                              const dateArrTo = field.valueTo.replace(/_/g, '').split('.').map(date => parseInt(date, 10));

                              const dateYearFrom = dateArrFrom[0];
                              const dateYearTo = dateArrTo[0];

                              if (dateYearFrom > dateYearTo) {
                                  fieldErrors.valueFrom = 'to_exceeds_from';
                              }
                         }

                         innerFieldsErrors[fieldIndex] = fieldErrors;
                     } else {
                         if (field.relation !== 'IS_EMPTY' && field.relation !== 'CONTAINS_ANYTHING' && !field.value) {
                             fieldErrors.value = 'required';
                             innerFieldsErrors[fieldIndex] = fieldErrors;
                         }
                     }
                 });

                 if (innerFieldsErrors.length) {
                     queryErrors.innerFields = innerFieldsErrors;
                     queryArrayErrors[index] = queryErrors;
                 }
             }
        });

        if (queryArrayErrors.length) {
            errors.searchQueries = queryArrayErrors;
        }
    }

    return errors;
};



// WEBPACK FOOTER //
// ./src/scripts/AdvancedSearchFormValidation.js